import { createContext } from 'react';
import { Goal } from 'shared/types/goal';

export type DeleteGoalsContextProps = {
  onDeleteGoals: (goals: Goal[]) => void;
};

export const DeleteGoalsContext = createContext<DeleteGoalsContextProps>({
  onDeleteGoals: () => {},
});
